import {Action, Module} from 'vuex-module-decorators';
import store from '../store';
import {UserModel} from '@/models/user.model';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {GoogleMapsMarker} from '@/utils/map';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'challenge_community';

// @ts-ignore
if (store.state.challenge_community) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ChallengeCommunityStoreModule extends EntityStateAdapter<UserModel> {


  get users(): UserModel[] {
    return this._entities;
  }

  get markers(): GoogleMapsMarker[] {
    const markers: GoogleMapsMarker[] = [];
    this._entities.forEach((v) => {
      if (v.contestant && v.contestant.latitude && v.contestant.longitude) {
        markers.push({
          title: `${v.first_name} ${v.last_name}`,
          label: `${v.contestant.location}`,
          position: {
            lng: Number(v.contestant.longitude),
            lat: Number(v.contestant.latitude),
          },
        })
      }
    });
    return markers
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchCommunity(challengeId: number): Promise<UserModel[]> {
    return await new ChallengesApi()
      .findCommunity(challengeId)
      .pipe(take(1))
      .toPromise()
  }
}
